export const deleteProductsPhysicalConfiguration = `mutation ($date: timestamp, $id: Int!) {
    item: update_prodigio_product_physical_configurations(where: {id: {_eq: $id}}, _set: {deleted: $date}) {
      affected_rows
    }
  }`;
